import * as React from 'react';
import './Breadcrumbs.scss';

export type PathData = {
    id: number;
    name: string;
};

export type BreadcrumbsProps = {
    path: PathData[];
    onClick: (path: PathData[]) => void;
};

const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = ({ onClick, path }) => {
    const isActive = (pathData: PathData) => pathData.id === path[path.length - 1].id;
    const getPathUpTo = (pathData: PathData) => {
        const index = path.findIndex(currentPathEntry => currentPathEntry.id === pathData.id);
        return path.slice(0, index + 1);
    };

    return (
        <ol className="breadcrumb">
            {path.map(pathData => (
                <li className={isActive(pathData) ? 'active' : ''} key={pathData.id}>
                    {isActive(pathData)
                        ? pathData.name
                     : (
                        <a className="clickable" role="button" onClick={() => onClick(getPathUpTo(pathData))}>
                            {pathData.name}
                        </a>
                    )}
                </li>
            ))}
        </ol>
    );
};

Breadcrumbs.displayName = 'Breadcrumbs';

export default Breadcrumbs;
